import { loadVideo } from './legacy/video/landing-page-hero-video' 

export const initAccordionBlock = async (containerEl, accordionBlocks, isMobileOnly = true) => {
    const setupBlock = async () => {
        const container = document.querySelector(containerEl);
        if (!container) return;
        
        const expandingBlocks = container.querySelectorAll(accordionBlocks);
        
        const removeAllEventListeners = () => {
            expandingBlocks.forEach(block => {
                block.removeEventListener('click', clickHandler);
            });
        };
      
        const clickHandler = (e) => {
            e.currentTarget.classList.toggle('show');
        };
        
        const setupEventListeners = async () => {
            removeAllEventListeners();
            
            expandingBlocks.forEach(block => {
                block.addEventListener('click', clickHandler);
            });
        };
        
        await setupEventListeners();
        
        window.addEventListener('resize', setupEventListeners);
        
        container.accordionCleanup = () => {
            window.removeEventListener('resize', setupEventListeners);
            removeAllEventListeners();
        };

        if (containerEl === '.key-takeaways') {
            loadVideo();
        }
    };
    
    const container = document.querySelector(containerEl);
    if (container) {
        if (container.accordionCleanup) {
            container.accordionCleanup();
        }
        setupBlock();
        return;
    }
    
    const observer = new MutationObserver((mutations, obs) => {
        const newContainer = document.querySelector(containerEl);
        if (newContainer) {
            obs.disconnect();
            if (newContainer.accordionCleanup) {
                newContainer.accordionCleanup();
            }
            setupBlock();
        }
    });
    
    if (document.body) {
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    } else {
        window.addEventListener('DOMContentLoaded', () => {
            const lateBody = document.body;
            if (lateBody) {
                observer.observe(lateBody, {
                    childList: true,
                    subtree: true
                });
            }
        });
    }
};

document.addEventListener("DOMContentLoaded", () => {
    initAccordionBlock('.expanding_cards_block', '.expanding_cards_block__card');
    initAccordionBlock('.faq_section', '.faq_section__card', false)
    initAccordionBlock('.key-takeaways', '.key-takeaway-block')
    initAccordionBlock('.risk_factors_section', '.key-takeaway-block')
});
